import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const AdjustableTextarea = ({ value = '', onBlur, onChange, onFocus }) => {
  const refTextarea = useRef(null);

  useEffect(() => {
    refTextarea.current.style.height = `${refTextarea.current.scrollHeight}px`;
  }, []);

  const handleChange = e => {
    e.persist();
    onChange(e);
  };

  const handleBlur = e => {
    onBlur && onBlur(e);
  };

  const handleFocus = e => {
    onFocus && onFocus(e);
  };

  const handleInput = e => {
    refTextarea.current.style.height = `${refTextarea.current.scrollHeight}px`;
  };

  return (
    <Textarea
      value={value}
      onBlur={handleBlur}
      onChange={handleChange}
      onFocus={handleFocus}
      ref={refTextarea}
      onInput={handleInput}
    />
  );
};

export default AdjustableTextarea;

const Textarea = styled.textarea`
  resize: none;
  overflow: hidden;
  width: 100%;
  height: 3.0625rem;
  font-family: ${props => props.theme.baseFont.fontFamily};
  font-weight: ${props => props.theme.baseFont.fontWeight};
  font-size: ${props => props.theme.input.fontSize};
  color: ${props => props.theme.input.fontColor};
  background-color: ${props => props.theme.input.backgroundColor};
  border-bottom: ${props => props.theme.input.borderBottom};
  border-left: ${props => props.theme.input.borderLeft};
  border-right: ${props => props.theme.input.borderRight};
  border-top: ${props => props.theme.input.borderTop};
  border-radius: ${props => props.theme.input.borderRadius ?? '0'};
  padding: ${props => props.theme.input.padding ?? '0.563rem 0.875rem'};
  outline: none;

  &:focus {
    background-color: ${props => props.theme.input.focus.backgroundColor};
    border-color: ${props => props.theme.input.focus.borderColor};
    border-width: ${props => props.theme.input.focus.borderWidth};
  }
`;
